module.exports = __webpack_public_path__ + "static/media/google_07.44b0a29a.svg";